import { EAddressCadastreSpecialFlowValidationErrorCodes } from '../types';

const SPECIAL_VALIDATION_ERROR_CODES = Object.values(EAddressCadastreSpecialFlowValidationErrorCodes);

/* eslint-disable  @typescript-eslint/no-explicit-any */
export function isAddressCadastreSpecialFlowValidationErrorCode(
  errorCodeOrMessage: any,
): errorCodeOrMessage is EAddressCadastreSpecialFlowValidationErrorCodes {
  return SPECIAL_VALIDATION_ERROR_CODES.includes(errorCodeOrMessage);
}
